import { Icon } from '@chakra-ui/react';

export const ArrowForward = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M5.20874 13H16.3787L11.4987 17.88C11.1087 18.27 11.1087 18.91 11.4987 19.3C11.8887 19.69 12.5187 19.69 12.9087 19.3L19.4987 12.71C19.8887 12.32 19.8887 11.69 19.4987 11.3L12.9187 4.69997C12.5287 4.30997 11.8987 4.30997 11.5087 4.69997C11.1187 5.08997 11.1187 5.71997 11.5087 6.10997L16.3787 11H5.20874C4.65874 11 4.20874 11.45 4.20874 12C4.20874 12.55 4.65874 13 5.20874 13Z"
      fill="currentColor"
    />
  </Icon>
);
